import { FieldArray, FieldArrayRenderProps } from 'react-final-form-arrays';
import { connect } from 'react-redux';

import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { getKnmFormRef } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import styles from './Judgment.module.scss';
import { IKnmErknmFormJudgmentSubjectData } from '../MainModule/interfaces/IKnmErknmFormJudgmentSubjectData';
import { CommonCatalogsNamesEnum } from '../../CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { SelectInputFieldAutoOptions } from '../../UIPackage/MainModule/components/SelectInputFieldAutoOptions';
import { IKnmErknmFormJudgmentAgainstInfo } from '../MainModule/interfaces/IKnmErknmFormJudgmentAgainstInfo';
import { IKnmErknmFormJudgmentActsAndDecisions } from '../MainModule/interfaces/IKnmErknmFormJudgmentActsAndDecisions';
import { TextareaField } from '../../UIPackage/MainModule/components/TextareaField';
import { JudgmentCancellationInformationTypesEnum } from '../../CorePackage/CatalogsModule/enums/JudgmentCancellationInformationTypesEnum';

interface IErknmJudgmentCancellationTableBodyProps {
  watchOnly: boolean;
  cancellationSubjectId: string;
  cancellationSubjectName: string;
  cancellationSubjectValue: IKnmErknmFormJudgmentSubjectData;
}

interface IErknmJudgmentCancellationTableBodyStoreProps {
  formRef: IKnmFormRef | undefined;
}

const ErknmJudgmentCancellationTableBodyWithoutStore = ({
  watchOnly,
  formRef,
  cancellationSubjectId,
  cancellationSubjectName,
  cancellationSubjectValue,
}: IErknmJudgmentCancellationTableBodyProps & IErknmJudgmentCancellationTableBodyStoreProps) => {
  const organizationBody = () => {
    return (
      <tr>
        <td className={styles.TableInformationText} style={{ width: '2%' }}>
          <span className={styles.RowCounter} />
        </td>
        <td className={styles.TableInformationText} style={{ width: '32%' }}>
          {
            formRef?.current
              .getFieldState('organizations')
              ?.value?.find(x => x.guid === cancellationSubjectValue.organizationGuid)?.organizationName
          }
        </td>
        <td style={{ width: '22%' }}>{cancellationSubjectValue.judgmentAgainstOrganizations?.punishmentType?.label}</td>
        <td
          id={`${cancellationSubjectId}.judgmentAgainstOrganizations.cancellationInformation`}
          className={styles.TableInformationText}
          style={{ width: '22%' }}
        >
          <SelectInputFieldAutoOptions
            name={`${cancellationSubjectName}.judgmentAgainstOrganizations.cancellationInformation`}
            isClearable={false}
            optionName={CommonCatalogsNamesEnum.JUDGMENT_CANCELLATION_INFORMATION}
            disabled={watchOnly}
          />
        </td>
        <td
          id={`${cancellationSubjectId}.judgmentAgainstOrganizations.explanation`}
          className={styles.TableInformationText}
          style={{ width: '22%' }}
        >
          <TextareaField
            name={`${cancellationSubjectName}.judgmentAgainstOrganizations.explanation`}
            disabled={watchOnly}
            placeholder="Введите пояснение"
          />
        </td>
      </tr>
    );
  };
  const officialPersonBody = () => {
    return (
      <FieldArray name={`${cancellationSubjectName}.judgmentAgainstOfficialPerson`}>
        {({ fields }: FieldArrayRenderProps<IKnmErknmFormJudgmentAgainstInfo, HTMLElement>) => {
          if (!fields.length) {
            return null;
          }

          return fields.map((cancellationOfficialPersonName, cancellationOfficialPersonIndex) => {
            const cancellationOfficialPersonValue: IKnmErknmFormJudgmentAgainstInfo =
              fields.value?.[cancellationOfficialPersonIndex];
            const cancellationOfficialPersonId = `${cancellationSubjectId}.judgmentAgainstOfficialPerson[${cancellationOfficialPersonValue.listId}]`;

            return (
              <tr key={cancellationOfficialPersonName}>
                <td className={styles.TableInformationText} style={{ width: '2%' }}>
                  <span className={styles.RowCounter} />
                </td>
                <td className={styles.TableInformationText} style={{ width: '32%' }}>
                  {cancellationOfficialPersonValue.officialPersonFio}
                </td>
                <td style={{ width: '22%' }}>{cancellationOfficialPersonValue.punishmentType?.label}</td>
                <td
                  id={`${cancellationOfficialPersonId}.cancellationInformation`}
                  className={styles.TableInformationText}
                  style={{ width: '22%' }}
                >
                  <SelectInputFieldAutoOptions
                    name={`${cancellationOfficialPersonName}.cancellationInformation`}
                    isClearable={false}
                    optionName={CommonCatalogsNamesEnum.JUDGMENT_CANCELLATION_INFORMATION}
                    disabled={watchOnly}
                  />
                </td>
                <td
                  id={`${cancellationOfficialPersonId}.explanation`}
                  className={styles.TableInformationText}
                  style={{ width: '22%' }}
                >
                  <TextareaField
                    name={`${cancellationOfficialPersonName}.explanation`}
                    disabled={watchOnly}
                    placeholder="Введите пояснение"
                  />
                </td>
              </tr>
            );
          });
        }}
      </FieldArray>
    );
  };
  const actsAndDecisionsBody = () => {
    return (
      <FieldArray name={`${cancellationSubjectName}.cancellationActsAndDecisions`}>
        {({ fields }: FieldArrayRenderProps<IKnmErknmFormJudgmentActsAndDecisions, HTMLElement>) => {
          if (!fields.length) {
            return null;
          }

          return fields.map((cancellationActsAndDecisionsName, cancellationActsAndDecisionsIndex) => {
            const cancellationActsAndDecisionsValue: IKnmErknmFormJudgmentActsAndDecisions =
              fields.value?.[cancellationActsAndDecisionsIndex];
            const cancellationActsAndDecisionsId = `${cancellationSubjectId}.cancellationActsAndDecisions[${cancellationActsAndDecisionsValue.listId}]`;

            return (
              <tr key={cancellationActsAndDecisionsName}>
                <td className={styles.TableInformationText}>
                  <span className={styles.RowCounter} />
                </td>
                <td className={styles.TableInformationText}>{cancellationActsAndDecisionsValue.title}</td>
                <td className={styles.TableInformationText}>
                  {cancellationActsAndDecisionsValue.cancellationInformation?.name ||
                    JudgmentCancellationInformationTypesEnum.CANCELLATION}
                </td>
                <td
                  className={styles.TableInformationText}
                  id={`${cancellationActsAndDecisionsId}.newCancellationInformation`}
                >
                  <SelectInputFieldAutoOptions
                    name={`${cancellationActsAndDecisionsName}.newCancellationInformation`}
                    isClearable={false}
                    optionName={CommonCatalogsNamesEnum.JUDGMENT_CANCELLATION_INFORMATION}
                    disabled={watchOnly}
                  />
                </td>
                <td id={`${cancellationActsAndDecisionsId}.newExplanation`} className={styles.TableInformationText}>
                  <TextareaField
                    name={`${cancellationActsAndDecisionsName}.newExplanation`}
                    disabled={watchOnly}
                    placeholder="Введите пояснение"
                  />
                </td>
              </tr>
            );
          });
        }}
      </FieldArray>
    );
  };

  return (
    <>
      {cancellationSubjectValue.isJudgmentAgainstOrganizations && organizationBody()}
      {cancellationSubjectValue.isJudgmentAgainstOfficialPerson && officialPersonBody()}
      {cancellationSubjectValue.cancellationActsAndDecisions && actsAndDecisionsBody()}
    </>
  );
};

const mapStateToProps = (state: IRootState): IErknmJudgmentCancellationTableBodyStoreProps => ({
  formRef: getKnmFormRef(state),
});

export const ErknmJudgmentCancellationTableBody = connect(mapStateToProps)(
  ErknmJudgmentCancellationTableBodyWithoutStore,
);
